module.exports = __webpack_public_path__ + "img/check-circle.ad13c79f.svg";